<script lang="ts" setup>
import {menuMainItems} from "~~/route/route.config";
import type {MenuItemRoute} from "~~/route/interface/menu-item-route.interface";

const {t, locale} = useI18n();
const navLinks: MenuItemRoute[] = menuMainItems.filter(i => i?.level1);
const config = useRuntimeConfig().public;
const {mobileMenuOpen, isMobileUi} = useSiteLayout();

useHead({
    bodyAttrs: {
        class: computed(() => mobileMenuOpen.value && isMobileUi.value ? 'overflow-hidden' : ''),
    },
});

</script>

<template>
  <Transition name="slide">
    <nav
      v-show="mobileMenuOpen"
      class="nav bg-light absolute inset-0 laptop:static laptop:bg-transparent z-10 flex flex-col laptop:flex-row flex-nowrap laptop:items-center justify-center laptop:justify-end">
      <ul class="flex flex-col tablet:items-start laptop:items-center laptop:flex-row flex-nowrap justify-center laptop:justify-start gap-4 laptop:gap-2 destop:gap-3">
        <li v-for="item in navLinks" :key="item.identifier" class="text-2xl tablet:text-base mb-4 tablet:mb-0">
          <NuxtLink
                  v-if="item?.path?.[locale] && (item.identifier === 'gift-card' ? config.gift_voucher.enabled : true)"
                  :to="item.path[locale]"
                  :class="{
                    'router-link px-4 mr-2': item.identifier !== 'gift-card',
                    'btn btn-outline-secondary': item.identifier == 'gift-card',
                    'tablet:hidden': item.identifier === 'home',
                  }"
                  @click="mobileMenuOpen = false"
          >
            {{ t(`nav.${item.identifier}`) }}
          </NuxtLink>
          <a
            v-else-if="item.url"
            :href="item.url"
            class="btn btn-secondary"
            @click="mobileMenuOpen = false"
          >
            {{ t(`nav.${item.identifier}`) }}
          </a>
        </li>
      </ul>
    </nav>
  </Transition>
</template>
<style scoped>
.slide-enter-active {
    transition: opacity .6s ease, transform .3s cubic-bezier(0,.55,.42,.99);
}

.slide-enter-from {
    transform: translateY(-75%);
    opacity: 0;
}

.slide-enter-to {
    transform: translateY(0);
    opacity: 1;
}

.slide-leave-from {
    transform: translateY(0);
    opacity: 1;
}

.slide-leave-to {
    transform: translateY(-75%);
    opacity: 0;
}

@media (min-width: 992px) {
    .nav {
        display: flex !important;
    }
}
</style>